const baseURL = `${process.env.REACT_APP_API_BASE_URL_ADA}/api`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to get checker details
const GetCheckerPartnerDetails = async (
    id: string, // scanning id
): Promise<any> => {    

    const url = `${baseURL}/checker/integration-request-status`;
    
    const data = new FormData();

    data.append("user_id", id);
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export { GetCheckerPartnerDetails }